import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { NavLink } from "react-router-dom";
import { classNames } from "primereact/utils";

export default function OverLayTable({
	className,
	headers = [
		{
			header_name: "Column 1",
			header_key: "column1",
		},
		{
			header_name: "Column 2",
			header_key: "column2",
		},
	],
	items = [
		{
			column1: "Column 2",
			column2: "Column 2",
		},
	],
	isNative = false,
	children,
	linkName,
	linkBody,
	fieldId,
	actionColumn,
	bottomAction,
}) {
	const withLinkTemplate = (rowData) => {
		return (
			<a
				className={"text-component-blueTextColor"}
				href={`${linkBody}/${rowData[fieldId]}`}
				target="_blank"
			>
				{rowData[linkName]}
			</a>
		);
	};

	return (
		<DataTable
			value={items}
			rowsPerPageOptions={[10, 20, 50]}
			rows={10}
			sortMode="multiple"
			sortField="name"
			sortOrder={1}
			stripedRows
			showGridlines
			tableStyle={{
				minWidth: "50rem",
				borderWidth: 2,
				borderColor: "#E6E6E6",
			}}
		>
			{headers.map((data, key) => {
				console.log(linkName, data.header_key);
				if (linkBody && linkName === data.header_key) {
					return (
						<Column
							field={data.header_key}
							header={data.header_name}
							body={withLinkTemplate}
							headerStyle={{ width: "3rem", backgroundColor: "#FECD08" }}
						></Column>
					);
				}
				return (
					<Column
						field={data.header_key}
						header={data.header_name}
						headerStyle={{ width: "3rem", backgroundColor: "#FECD08" }}
					></Column>
				);
			})}
		</DataTable>
	);
}
